import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@altertec_gparn/lib";

export default {
  path: "/warehouse",
  name: "Warehouse",
  meta: { sectionAccess: "WAREHOUSE", redirects: true },
  component: () => import("@/layouts/EmptyLayout.vue"),
  children: [
    {
      path: "warehouses",
      name: "Warehouses Layout",
      meta: { permissions: [PermissionEnum.WAREHOUSE_WAREHOUSES] },
      redirect: { name: "Warehouses" },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "",
          name: "Warehouses",
          component: () => import("@/views/auth/warehouse/warehouse/WarehouseList.vue"),
        },
        {
          path: "detail/:id",
          name: "Warehouses Detail Layout",
          redirect: { name: "Warehouse Detail" },
          meta: { permissions: [PermissionEnum.WAREHOUSE_WAREHOUSES] },
          component: () => import("@/layouts/EmptyLayout.vue"),
          props: true,
          children: [
            {
              path: "",
              name: "Warehouse Detail",
              redirect: { name: "Stock Tab" },
              component: () => import("@/views/auth/warehouse/warehouse/WarehouseDetail.vue"),
              props: true,
              children: [
                {
                  path: "stock",
                  name: "Stock Tab",
                  component: () => import("@/modules/warehouse/tabs/WarehouseStockTab.vue"),
                  props: true,
                },
                {
                  path: "history",
                  name: "History Tab",
                  component: () => import("@/modules/warehouse/tabs/WarehouseStockHistoryTab.vue"),
                  props: true,
                },
                {
                  path: "item",
                  name: "Item Tab",
                  component: () => import("@/modules/warehouse/tabs/WarehouseItemTab.vue"),
                  props: true,
                },
                {
                  path: "locations",
                  name: "Locations Tab",
                  component: () => import("@/modules/warehouse/tabs/WarehouseLocationsTab.vue"),
                  props: true,
                },
              ],
            },
            {
              path: "consumable/:consumableId",
              name: "Warehouse Consumable",
              component: () => import("@/views/auth/warehouse/WarehouseConsumableDetail.vue"),
              props: true,
            },
            {
              path: "locations",
              name: "Locations",
              redirect: { name: "Location List" },
              meta: { permissions: [PermissionEnum.WAREHOUSE_WAREHOUSES] },
              component: () => import("@/layouts/EmptyLayout.vue"),
              children: [
                {
                  path: "list",
                  name: "Location List",
                  component: () => import("@/views/auth/warehouse/locations/LocationsList.vue"),
                  props: true,
                },
                {
                  path: "new",
                  name: "Location New",
                  component: () => import("@/views/auth/warehouse/locations/LocationCreate.vue"),
                  props: true,
                },
                {
                  path: "detail/:locationId",
                  name: "Location Detail",
                  component: () => import("@/views/auth/warehouse/locations/LocationDetail.vue"),
                  props: true,
                },
                {
                  path: "edit/:locationId",
                  name: "Location Edit",
                  component: () => import("@/views/auth/warehouse/locations/LocationEdit.vue"),
                  props: true,
                },
              ],
            },
          ],
        },
        {
          path: "new",
          name: "Warehouse New",
          component: () => import("@/views/auth/warehouse/warehouse/WarehouseNew.vue"),
        },
        {
          path: "edit/:id",
          name: "Warehouse Edit",
          component: () => import("@/views/auth/warehouse/warehouse/WarehouseEdit.vue"),
          props: true,
        },
      ],
    },
    {
      path: "purchase-orders",
      name: "Purchase Orders Layout",
      meta: { permissions: [PermissionEnum.WAREHOUSE_PURCHASE_ORDERS] },
      redirect: { name: "Purchase Orders" },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "",
          name: "Purchase Orders",
          component: () => import("@/views/auth/warehouse/purchase-orders/PurchaseOrdersList.vue"),
        },
        {
          path: "detail/:id?",
          name: "Purchase Order Detail Layout",
          component: () => import("@/views/auth/warehouse/purchase-orders/PurchaseDetail.vue"),
          props: true,
          children: [
            {
              path: "",
              name: "Purchase Order Detail",
              components: {
                sidebar: () => import("@/modules/warehouse/components/sidebars/PurchaseOrderAttachmentsSidebar.vue"),
              },
              props: true,
            },
            {
              path: "import-lines",
              name: "Purchase Order Import Lines",
              components: {
                sidebar: () => import("@/modules/warehouse/ImportPurchaseOrderLinesTemplate.vue"),
              },
              props: true,
            },
          ],
        },
        {
          path: "new",
          name: "Purchase Order New",
          component: () => import("@/views/auth/warehouse/purchase-orders/PurchaseOrderUpdate.vue"),
        },
        {
          path: "edit/:id",
          name: "Purchase Order Edit",
          component: () => import("@/views/auth/warehouse/purchase-orders/PurchaseOrderUpdate.vue"),
          props: true,
        },
      ],
    },

    {
      path: "delivery-notes",
      name: "Delivery Notes Layout",
      meta: { permissions: [PermissionEnum.WAREHOUSE_DELIVERY_NOTES] },
      redirect: { name: "Delivery Notes" },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "",
          name: "Delivery Notes",
          component: () => import("@/views/auth/warehouse/delivery-notes/DeliveryNoteList.vue"),
        },
        {
          path: "detail/:id?",
          name: "Delivery Note Detail",
          component: () => import("@/views/auth/warehouse/delivery-notes/DeliveryNoteDetail.vue"),
          props: true,
        },
        {
          path: ":purchaseOrderId/new",
          name: "Delivery Note New",
          component: () => import("@/views/auth/warehouse/delivery-notes/DeliveryNoteUpdate.vue"),
        },
        {
          path: "edit/:id",
          name: "Delivery Notes Edit",
          component: () => import("@/views/auth/warehouse/delivery-notes/DeliveryNoteUpdate.vue"),
          props: true,
        },
        {
          path: "return/:id",
          name: "Delivery Note Return",
          component: () => import("@/views/auth/warehouse/delivery-notes/DeliveryNoteReturnDetail.vue"),
          props: true,
        },
      ],
    },
    {
      path: "consumables",
      name: "Consumable Layout",
      meta: { permissions: [PermissionEnum.WAREHOUSE_CONSUMABLES] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "",
          name: "Consumables",
          component: () => import("@/views/auth/warehouse/consumables/ConsumableList.vue"),
          children: [
            {
              path: "import",
              name: "Consumables Import",
              meta: {
                permissions: [PermissionEnum.WAREHOUSE_CONSUMABLES, PermissionEnum.WAREHOUSE_CONSUMABLES_CREATE],
              },
              components: {
                sidebar: () => import("@/modules/consumables/ImportConsumableTemplate.vue"),
              },
            },
          ],
        },
        {
          path: "detail/:id?",
          name: "Consumable Detail",
          component: () => import("@/views/auth/warehouse/consumables/ConsumableDetail.vue"),
          props: true,
        },
        {
          path: "new",
          name: "Consumable New",
          meta: {
            permissions: [PermissionEnum.WAREHOUSE_CONSUMABLES, PermissionEnum.WAREHOUSE_CONSUMABLES_CREATE],
          },
          component: () => import("@/views/auth/warehouse/consumables/ConsumableNew.vue"),
        },
        {
          path: "edit/:id",
          name: "Consumable Edit",
          component: () => import("@/views/auth/warehouse/consumables/ConsumableEdit.vue"),
          props: true,
        },
        {
          path: ":id/external-references",
          name: "Consumable External References",
          component: () => import("@/views/auth/warehouse/consumables/ConsumableExternalReferences.vue"),
          props: true,
        },
      ],
    },
    {
      path: "services",
      name: "Services Layout",
      meta: { permissions: [PermissionEnum.WAREHOUSE_SERVICES] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "",
          name: "Services",
          component: () => import("@/views/auth/warehouse/services/ServiceList.vue"),
        },
        {
          path: "detail/:id?",
          name: "Service Detail",
          component: () => import("@/views/auth/warehouse/services/ServiceDetail.vue"),
          props: true,
        },
        {
          path: "new",
          name: "Service New",
          meta: {
            permissions: [PermissionEnum.WAREHOUSE_SERVICES, PermissionEnum.WAREHOUSE_SERVICES_CREATE],
          },
          component: () => import("@/views/auth/warehouse/services/ServiceNew.vue"),
        },
        {
          path: "edit/:id",
          name: "Service Edit",
          component: () => import("@/views/auth/warehouse/services/ServiceEdit.vue"),
          props: true,
        },
      ],
    },
    {
      path: "items",
      name: "Items",
      redirect: { name: "Item List" },
      meta: { permissions: [PermissionEnum.WAREHOUSE_ITEMS] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      props: true,
      children: [
        {
          path: "list",
          name: "Item List",
          component: () => import("@/views/auth/warehouse/items/ItemList.vue"),
        },
        {
          path: "new",
          name: "Item New",
          meta: {
            permissions: [PermissionEnum.WAREHOUSE_ITEMS, PermissionEnum.WAREHOUSE_ITEMS_CREATE],
          },
          component: () => import("@/views/auth/warehouse/items/ItemNew.vue"),
        },
        {
          path: "edit/:itemId",
          name: "Item Edit",
          component: () => import("@/views/auth/warehouse/items/ItemEdit.vue"),
          props: true,
        },
        {
          path: "detail/:itemId",
          name: "Item Detail",
          redirect: { name: "Item Amortization" },
          component: () => import("@/views/auth/warehouse/items/ItemDetail.vue"),
          props: true,
          children: [
            {
              path: "amortization",
              name: "Item Amortization",
              components: {
                sidebar: () => import("@/modules/warehouse/components/sidebars/ItemRightSidebar.vue"),
                default: () => import("@/views/auth/warehouse/items/ItemAmortizationTab.vue"),
              },
              props: true,
            },
            {
              path: "files",
              name: "Item Files",
              components: {
                sidebar: () => import("@/modules/warehouse/components/sidebars/ItemRightSidebar.vue"),
                default: () => import("@/views/auth/warehouse/items/ItemFilesTab.vue"),
              },
              props: true,
            },
          ],
        },
      ],
    },
    {
      path: "stock-records",
      name: "Stock Records",
      redirect: { name: "Stock Record List" },
      meta: { permissions: [PermissionEnum.WAREHOUSE_STOCK_RECORDS] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list",
          name: "Stock Record List",
          redirect: { name: "Stock Record List Page" },
          component: () => import("@/views/auth/warehouse/stock-records/StockRecords.vue"),
          children: [
            {
              path: "",
              name: "Stock Record List Page",
              components: {
                sidebar: () => import("@/modules/warehouse/components/sidebars/BulkDeductStockRecordSidebar.vue"),
              },
            },
            {
              path: "bulk-deduct",
              name: "Stock Record Bulk Deduct",
              components: {
                sidebar: () => import("@/modules/warehouse/components/sidebars/BulkDeductStockRecordSidebar.vue"),
              },
            },
          ],
        },
        {
          path: "deduct",
          name: "Deduct Stock Record",
          component: () => import("@/views/auth/warehouse/stock-records/DeductStockRecordFormPage.vue"),
        },
        {
          path: "detail/:id",
          name: "Stock Record Detail",
          redirect: { name: "Stock Record Detail Sidebar" },
          component: () => import("@/views/auth/warehouse/stock-records/StockRecordDetail.vue"),
          children: [
            {
              path: "",
              name: "Stock Record Detail Sidebar",
              components: {
                sidebar: () => import("@/views/auth/warehouse/stock-records/MoveStockSidebar.vue"),
              },
              props: true,
            },
          ],
          props: true,
        },
      ],
    },
    {
      path: "configuration",
      name: "Warehouses Configuration",
      redirect: { name: "Metrics" },
      meta: { permissions: [PermissionEnum.WAREHOUSE_CONFIGURATION] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "metrics/:type?/:id?",
          name: "Metrics",
          meta: { permissions: [PermissionEnum.WAREHOUSE_CONFIGURATION] },
          component: () => import("@/views/auth/configuration/Metrics.vue"),
          props: true,
        },
        {
          path: "item-models/:type?/:id?",
          name: "ItemModels",
          meta: { permissions: [PermissionEnum.WAREHOUSE_CONFIGURATION] },
          component: () => import("@/views/auth/configuration/ItemModels.vue"),
          props: true,
          children: [
            {
              path: "import",
              name: "ItemModels Import",
              components: {
                sidebar: () => import("@/modules/item-models/ImportItemModelTemplate.vue"),
              },
            },
          ],
        },
        {
          path: "categories/:type?/:id?",
          name: "Categories",
          meta: { permissions: [PermissionEnum.WAREHOUSE_CONFIGURATION] },
          component: () => import("@/views/auth/configuration/Categories.vue"),
          props: true,
        },
        {
          path: "subcategories/:type?/:id?",
          name: "Subcategories",
          meta: { permissions: [PermissionEnum.WAREHOUSE_CONFIGURATION] },
          component: () => import("@/views/auth/configuration/Subcategories.vue"),
          props: true,
        },
        {
          path: "brands/:type?/:id?",
          name: "Brands",
          meta: { permissions: [PermissionEnum.WAREHOUSE_CONFIGURATION] },
          component: () => import("@/views/auth/configuration/Brands.vue"),
          props: true,
        },
        {
          path: "approval-permissions",
          name: "Purchase Approval Configuration",
          meta: {
            permissions: [PermissionEnum.WAREHOUSE_PURCHASE_ORDER_APPROVAL_CONFIGURATION],
          },
          component: () => import("@/views/auth/warehouse/purchase-orders/PurchaseApprovalConfiguration.vue"),
        },
        {
          path: "addresses/:type?/:id?",
          name: "Addresses",
          component: () => import("@/views/auth/configuration/Addresses.vue"),
          props: true,
        },
      ],
    },
    {
      path: "suppliers/:type?/:id?",
      name: "Warehouse Suppliers",
      meta: { permissions: [PermissionEnum.WAREHOUSE_CONFIG_SUPPLIERS] },
      component: () => import("@/views/auth/warehouse/WarehouseSuppliers.vue"),
      props: true,
    },
    {
      path: "issues",
      name: "Warehouse Issues Layout",
      redirect: { name: "Warehouse Issues List" },
      meta: { permissions: [PermissionEnum.WAREHOUSE_ISSUES] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          name: "Warehouse Issues List",
          path: "",
          component: () => import("@/views/auth/warehouse/warehouse-issues/WarehouseIssuesList.vue"),
          children: [
            {
              path: "create-warehouse-issue",
              name: "Create Warehouse Issue Sidebar",
              components: {
                sidebar: () => import("@/modules/warehouse/components/sidebars/CreateWarehouseIssueSidebar.vue"),
              },
            },
          ],
        },
        {
          name: "Warehouse Issue Detail",
          path: "detail/:id",
          redirect: { name: "Warehouse Issue Sidebar" },
          component: () => import("@/views/auth/warehouse/warehouse-issues/WarehouseIssueDetail.vue"),
          props: true,
          children: [
            {
              path: "",
              name: "Warehouse Issue Sidebar",
              components: {
                sidebar: () => import("@/modules/warehouse/components/sidebars/WarehouseIssueRightSidebar.vue"),
              },
              props: true,
            },
          ],
        },
      ],
    },
  ],
} as RouteRecordRaw;
